import { z } from 'zod';

export const ACTIVATION_ACTIONS = {
  ACTIVATE: 'activate',
  DEACTIVATE: 'deactivate',
  NONE: '',
} as const;

export const activationActionSchema = z.union([
  z.literal(ACTIVATION_ACTIONS.ACTIVATE),
  z.literal(ACTIVATION_ACTIONS.DEACTIVATE),
  z.literal(ACTIVATION_ACTIONS.NONE),
]);
